"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    requestTotalAttempts: 5,
    callbackCallDelay: 5000,
    chainRequestTimeout: 5000,
    maxNodeResponseTime: 99999,
};
